import { isBrowser } from './browserHelper';

export const PLAIN_VIEW = 'alt';

export const isPlainView = (): boolean => {
  if (!isBrowser()) return false;
  return window.location.pathname
    .split('/')
    .some((urlPart) => urlPart === PLAIN_VIEW);
};

export const isInsideIframe = (): boolean => {
  if (!isBrowser()) return false;
  return window.self !== window.top;
};
